export default __webpack_public_path__ + "static/media/bomb1.dab46aa2.svg";